<template>
    <div>
        <app-title text="PQR's" />
        <app-petitions-review-filters @filter="onFilter" :is-assigned="true" />
        <app-petitions-review-list
            :data="data"
            :on-change-page="onChangePage"
            :see-more="seeMore"
            :start-add-comment="startAddComment"
            :startApprove="startApprove"
            :startRejectPetition="startRejectPetition"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->
        <app-pop-up
            id="view-petition-more-assigned-petitions"
            title="Petición"
            size="large"
        >
            <div slot="body">
                <div class="petition-description mb-2">
                    <h5 style="text-align:center">
                        <label for="anotation">Descripción</label>
                    </h5>
                    <textarea
                        type="text"
                        id="anotation"
                        class="form-control"
                        disabled="true"
                        cols="80"
                        rows="5"
                        v-model="petitionView.description"
                    ></textarea>
                </div>
                <b-tabs content-class="mt-3">
                    <b-tab title="Info General" active>
                        <div class="row">
                            <div class="col-6">
                                <h5>Fecha de creación</h5>
                                <label>{{
                                    petitionView.date | datetime
                                }}</label>
                            </div>
                            <div class="col-6">
                                <h5>Tipo de petición</h5>
                                <label>{{ petitionView.type }}</label>
                            </div>
                            <div class="col-6">
                                <h5>Cliente</h5>
                                <label>{{ petitionView.client }}</label>
                            </div>
                            <div class="col-6">
                                <h5>Usuario</h5>
                                <label>{{ petitionView.user }}</label>
                            </div>
                            <div class="col-6">
                                <h5>Estado</h5>
                                <label>{{ petitionView.status }}</label>
                            </div>
                            <div class="col-6">
                                <h5>Usuarios asignados</h5>
                                <div v-if="petitionView.assignments">
                                    <div
                                        v-for="assignment in petitionView.assignments"
                                        :key="assignment.id"
                                    >
                                        {{
                                            assignment.inactive
                                                ? assignment.user.name
                                                : assignment.user.name +
                                                  ' (Actualmente)'
                                        }}
                                    </div>
                                </div>
                                <div v-if="!petitionView.assignments.length">
                                    No tiene
                                </div>
                            </div>
                        </div>
                        <br />
                    </b-tab>
                    <b-tab title="Comentarios">
                        <b-table
                            striped
                            :fields="commentsFields"
                            :items="petitionView.comments"
                        >
                            <template slot="created_at" slot-scope="{ item }">
                                <small>{{ item.created_at | datetime }}</small>
                            </template>
                            <template slot="action" slot-scope="{ item }">
                                <div v-if="!item.public">
                                    <app-btn-confirm
                                        @confirm="publishComment(item)"
                                        variant="primary"
                                        v-if="userCan('public-pqr-comments')"
                                    >
                                        Publicar
                                    </app-btn-confirm>
                                </div>
                                <span v-else
                                    ><b-alert show variant="success"
                                        >Público</b-alert
                                    ></span
                                >
                            </template>
                        </b-table>
                    </b-tab>
                </b-tabs>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Agregar comentario a la petición"
            id="petition-comment-assigned-petitions"
            :onClose="cleanFormComment"
        >
            <div class="body" slot="body">
                <app-add-petition-comment
                    id="petition-comment-assigned-petitions"
                    :petition="petitionSelected"
                    :on-save="onSaveComment"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="
                        $bus.$emit('petition-comment-assigned-petitions.save')
                    "
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Aprobación de petición"
            id="approve-petition-client"
            :onClose="cleanPetitionSelected"
        >
            <div class="body" slot="body">
                <h5>¿Esta seguro que desea aprobar esta petición?</h5>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="approve(petitionSelected)"
                >
                    Aprobar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Rechazo de petición"
            id="reject-petition-client"
            :onClose="cleanPetitionReject"
        >
            <div class="body" slot="body">
                <h5>¿Esta seguro que desea rechazar esta petición?</h5>
                <label
                    >Agregue comentario justificando porque rechazo la
                    solución</label
                >
                <app-add-petition-comment
                    id="petition-comment-client"
                    :petition="petitionSelected"
                    :disabled="inProgress"
                    :on-save="rejectConfirm"
                    errorMessage="Debe escribir el comentario"
                    :required="true"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="reject(petitionSelected)"
                >
                    Rechazar
                </button>
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import petitionsRepository from '../../../repositories/petitions.repository.js'
import AddPetitionComment from '../PetitionComment/AddPetitionComment.vue'
import { mapGetters } from 'vuex'
import PetitionsReviewList from './PetitionsReviewList/PetitionsReviewList.vue'
import PetitionsReviewFilters from './PetitionsReviewFilters/PetitionsReviewFilters.vue'

export default {
    components: {
        appAddPetitionComment: AddPetitionComment,
        appPetitionsReviewList: PetitionsReviewList,
        appPetitionsReviewFilters: PetitionsReviewFilters,
    },

    data() {
        return {
            petitionView: {
                user: '',
                client: '',
                type: '',
                date: '',
                description: '',
                status: '',
                assignments: [],
                comments: [],
            },
            data: {},
            petitionSelected: {},
            page: 1,
            sort: {
                sortBy: 'created_at',
                sortDir: 'asc',
            },
            filters: {},
            publish: false,
            confirm: true,
            commentsFields,
        }
    },
    methods: {
        async publishComment(item) {
            const { data } = await repo.post(
                `petitions/${item.id}/change-status-comment`
            )
            if (data.status) {
                toastr.success(data.msg)
                this.loadPetitions()
                this.$bus.$emit('view-petition-more-assigned-petitions.close')
            } else {
                toastr.error(data.msg)
            }
        },
        openConfirm() {
            this.publish = true
            this.confirm = false
        },
        cancel() {
            this.publish = false
            this.confirm = true
        },
        loadPetitions() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            const pr = Object.assign({}, petitionsRepository)
            pr.loadPetitions(filters, this.page)
                .then(data => {
                    this.data = data
                })
                .catch(error => toastr.error('Error al cargar las peticiones'))
        },
        onChangePage(page) {
            this.page = page
            this.loadPetitions()
        },
        seeMore(petition) {
            Object.keys(this.petitionView).map(
                key => (this.petitionView[key] = '')
            )
            this.petitionView.user = petition.user.name
            this.petitionView.client = petition.client.name
            this.petitionView.type = petition.petition_type.name
            this.petitionView.date = petition.created_at
            this.petitionView.description = petition.description
            this.petitionView.status = petition.petition_status.name
            this.petitionView.assignments = petition.petition_assignment
            this.petitionView.comments = petition.comments

            this.$bus.$emit('view-petition-more-assigned-petitions.open')
        },
        startAddComment(petition) {
            this.petitionSelected = petition
            this.$bus.$emit('petition-comment-assigned-petitions.open')
        },
        startApprove(petition) {
            this.petitionSelected = petition
            this.$bus.$emit('approve-petition-client.open')
        },
        startRejectPetition(petition) {
            this.petitionSelected = petition
            this.$bus.$emit('reject-petition-client.open')
        },
        onSaveComment() {
            this.$bus.$emit('petition-comment-assigned-petitions.close')
            this.loadPetitions()
        },
        cleanFormComment() {
            this.$bus.$emit('petition-comment-assigned-petitions.clean')
        },
        onFilter(filters) {
            this.filters = filters
            this.page = 1
            this.loadPetitions()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadPetitions()
        },
        cleanPetitionSelected() {
            this.petitionSelected = {}
        },
        cleanPetitionReject() {
            this.petitionSelect = {}
            this.$bus.$emit('petition-comment-client.clean')
        },
        approve() {
            const formData = new FormData()
            formData.append('userId', this.user.id)

            const pr = Object.assign({}, petitionsRepository)
            pr.approvePetitionByClient(this.petitionSelected.id, formData)
                .then(data => {
                    this.petitionSelected = {}
                    this.$bus.$emit('approve-petition-client.close')
                    this.loadPetitions()
                    toastr.success('Petición aprobada correctamente')
                })
                .catch(error => {
                    toastr.error('No fue posible aprobar la petición')
                })
        },
        reject() {
            this.$bus.$emit('petition-comment-client.save')
        },
        rejectConfirm() {
            const formData = new FormData()
            formData.append('userId', this.user.id)

            const pr = Object.assign({}, petitionsRepository)
            pr.rejectPetitionByClient(this.petitionSelected.id, formData)
                .then(data => {
                    this.petitionSelected = {}
                    this.$bus.$emit('reject-petition-client.close')
                    this.loadPetitions()
                    toastr.success('Petición rechazada correctamente')
                    this.onSaveComment()
                })
                .catch(error => {
                    toastr.error('No fue posible rechazar la petición')
                })
        },
    },

    created() {
        this.loadPetitions()
    },
}

const commentsFields = [
    {
        key: 'created_at',
        label: 'Fecha',
    },
    {
        key: 'user.name',
        label: 'Usuario',
    },
    {
        key: 'comment',
        label: 'Comentario',
    },
    {
        key: 'action',
        label: 'accion',
    },
]
</script>
